const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const AutoResolveReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_AUTO_RESOLVE_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_AUTO_RESOLVE_LIST":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_AUTO_RESOLVE_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default AutoResolveReducer;